
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>note_add</mat-icon>
    </span>
    My Forms
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>


    <div class="myforms">
      <div class="drive mainLink">
        <div class="folderName" (click)="GetAllForms()">
          <mat-icon class="type">account_balance</mat-icon>
          Forms
        </div>

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }" *matTreeNodeDef="let node"
            matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility: hidden;">
                arrow_right
              </mat-icon>

              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder_shared</mat-icon>
                <span class="flname" (click)="getFormFolderWithTemplatesLeftPanel(node)">{{node.formFolderName}}</span>
              </div>
            </div>
          </mat-tree-node>

          <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }"
            *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.formFolderName">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
              </mat-icon>
              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder_shared</mat-icon>
                <span class="flname" (click)="getFormFolderWithTemplatesLeftPanel(node)">{{node.formFolderName}}</span>
              </div>
            </div>

          </mat-tree-node>
        </mat-tree>

        <div class="folderName" (click)="getSharedWithMe()" [ngClass]="{ 'active': SharedWithMeactive }">
          <mat-icon class="type">portrait</mat-icon> Shared with me
        </div>

      </div>

      <div class="driveDetail" *ngIf="isShowForm">

        <div class="breadcumb">
          <span (click)="breadCrumbMainClick()">Forms</span>
          <span *ngFor="let m of menuHeader;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumb(menuHeader, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of FormFolderListMiddleSection; let i = index;">
                <tr class="mat-row foldericon" (click)="checkboxChecked(form,'MyForm')">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.type == 2">
                      <mat-checkbox color="primary"
                      [(ngModel)]="form.isChecked"
                      (change)="checkboxChange(form, 'MyForm',$event.checked)">
                      </mat-checkbox>

                      <!-- <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChange(form,'MyForm')">
                      </mat-radio-button> -->
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>

                  <td class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == false">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == true">
                    <mat-icon>folder_shared</mat-icon>
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==1">
                    <img src="../../../../assets/images/icons/formIcon.svg" alt="" width="28" />
                    <!-- <mat-icon>description</mat-icon> -->
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==2">
                    <img src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="28" />
                    <!-- <mat-icon>table_rows</mat-icon> -->
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==3">
                    <img src="../../../../assets/images/icons/form_html.svg" alt="" width="28" />
                    <!-- <mat-icon>table_rows</mat-icon> -->
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 1">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell">
                    {{ form.createdOn +'Z'| date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn!=null">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn==null">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>


                </tr>
              </ng-container>

              <ng-container *ngIf="!FormFolderListMiddleSection">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </mat-card>
      </div>

      <div class="driveDetail" *ngIf="isSharedWithMe">

        <div class="breadcumb">
          <span (click)="breadCrumbMainSHaredWithMeClick()">Shared with me</span>
          <span *ngFor="let m of menuHeader;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumb(menuHeader, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell" *ngIf="parentID==0">Shared By</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of SharedWithMeFormFolderList; let i = index;">
                <tr class="mat-row foldericon" (click)="checkboxChecked(form,'SharedWithMe')">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.type == 2">
                       <mat-checkbox color="primary"
                        [(ngModel)]="form.isChecked"
                        (change)="checkboxChange(form, 'SharedWithMe',$event.checked)">
                      </mat-checkbox>

                      <!-- <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChange(form,'SharedWithMe')">
                      </mat-radio-button> -->
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>

                  <td class="mat-cell docType" *ngIf="form.type == 1">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==1">
                    <img src="../../../../assets/images/icons/formIcon.svg" alt="" width="28" />
                    <!-- <mat-icon>description</mat-icon> -->
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==2">
                    <!-- <mat-icon>table_rows</mat-icon> -->
                    <img src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="28" />
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==3">
                    <!-- <mat-icon>table_rows</mat-icon> -->
                    <img src="../../../../assets/images/icons/form_html.svg" alt="" width="28" />
                  </td>

                  <td class="mat-cell" (click)="getFormFolderWithFormTemplatesSharedWithMe(form)"
                    *ngIf="form.type == 1">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="parentID==0">
                    <span class="formName" matTooltipClass="tooltip">
                      {{ form.sharedbyFirstName }} {{ form.sharedbyLastName }}
                    </span>
                  </td>

                  <td class="mat-cell" (click)="getFormFolderWithFormTemplatesSharedWithMe(form)"
                    *ngIf="form.type == 1">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" (click)="getFormFolderWithFormTemplatesSharedWithMe(form)"
                    *ngIf="form.type == 1">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                </tr>
              </ng-container>

              <ng-container *ngIf="SharedWithMeFormFolderList.length==0">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </mat-card>
      </div>

    </div>


  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button color="basic" (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!selectButtonShow" (click)="SelectFormSubmit()">Select</button>
  </mat-dialog-actions>
